var _path, _path2, _path3, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncorrectFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 -0.000610352L28 7.99939L28 23.9994L14 31.9994L0 23.9994V7.99939L14 -0.000610352Z",
    fill: "#FEF5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 -0.000610352V7.99939V23.9994V31.9994L0 23.9994V7.99939L14 -0.000610352Z",
    fill: "#ED3431"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 -0.000610352V7.99939V23.9994V31.9994L0 23.9994V7.99939L14 -0.000610352Z",
    fill: "#FBD6D6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.6001,
    y: 21.9994,
    width: 2.26274,
    height: 14.7078,
    rx: 1.13137,
    transform: "rotate(-135 9.6001 21.9994)",
    fill: "#A41034"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11.5994,
    width: 2.26274,
    height: 14.7078,
    rx: 1.13137,
    transform: "rotate(-45 8 11.5994)",
    fill: "#A41034"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrectFeedbackIcon);
export default __webpack_public_path__ + "static/media/incorrect-feedback-icon.cbffc7f5837776370f8fa8eec47ecdb2.svg";
export { ForwardRef as ReactComponent };